export default __webpack_public_path__ + "static/grass-1500-3f88e7ce442c65f261ae27c0132b2a67.jpg";